import { render, staticRenderFns } from "./EditarEnvioLabAux.vue?vue&type=template&id=297b68da"
import script from "./EditarEnvioLabAux.vue?vue&type=script&lang=js"
export * from "./EditarEnvioLabAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports